/**
 * @fileoverview `ConsoleLayout` — layout principal de la console backoffice.
 *
 * Utilise `SidebarProvider` + `AppSidebar` (Sidebar-07 shadcn colorisée
 * navy Quipux) + `SidebarInset` pour le contenu à droite. La sidebar est
 * collapsible (icônes uniquement) et responsive (drawer sur mobile via
 * SidebarProvider).
 *
 * Le lien "Design system" n'apparaît PAS ici — la page reste accessible
 * par URL directe (`/design-system`) et dispose de son propre layout
 * (`DesignSystemLayout`) qui remplace la sidebar par la liste des sections.
 *
 * TODO :
 *   - Brancher les données réelles quand les endpoints admin seront prêts.
 *   - Remplacer la recherche rapide mockée par une CommandPalette.
 */

import { Outlet } from 'react-router-dom';
import { SidebarInset, SidebarProvider } from '@gnpc/ui';
import { AlertingBanner } from '../features/console/AlertingBanner.tsx';
import { AppSidebar } from '../features/console/AppSidebar.tsx';
import { ConsoleTopBar } from '../features/console/ConsoleTopBar.tsx';

export function ConsoleLayout(): JSX.Element {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0">
        <ConsoleTopBar />
        {/* `<div>` et non `<main>` : `SidebarInset` rend déjà un `<main>`
          * (shadcn Sidebar-07) — un second landmark main imbriqué violait
          * axe `landmark-no-duplicate-main` et le validateur W3C. */}
        <div className="min-w-0 flex-1 overflow-x-hidden p-4 pb-8 md:p-6 md:pb-10 xl:p-8">
          {/* Bandeau d'anomalies STI global : visible sur toutes les pages de
            * la console tant que des paiements encaissés restent non
            * enregistrés. Le wrapper `empty:hidden` évite une marge fantôme
            * quand le bandeau ne rend rien. */}
          <div className="mb-4 empty:hidden md:mb-6">
            <AlertingBanner />
          </div>
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
